module.exports = __webpack_public_path__ + "img/sv_SE.34311b36.png";